const setSpouseCitizenIdExpireDate = (data = null,text = null) => {
  return {
    type: 'SET_SPOUSECITIZENIDEXPIREDATE',
    data,
    text
  }
}

export default {
  setSpouseCitizenIdExpireDate,
}
